<!-- TODO: updating element position when moving it up or down -->
<!-- TODO: fix bug when moving a newly added element -->
<script lang="ts">
  import ListingInfoBox from '#listings/components/listing_info_box.svelte'
  import type { SerializedListingWithElements } from '#listings/lib/listings'
  import { I18n } from '#user/lib/i18n'
  import { mainUser } from '#user/lib/main_user'
  import type { SerializedUser } from '#users/lib/users'
  import ListingElements from './listing_elements.svelte'

  const {
    listing,
    creator,
  }: {
    listing: SerializedListingWithElements
    creator: SerializedUser
  } = $props()

  const _id = $derived(listing._id)
  let elements = $derived(listing.elements)

  const isEditable = $derived(creator._id === mainUser?._id)
</script>

<div class="listing-layout">
  <ListingInfoBox
    {listing}
    {creator}
    {isEditable}
  />
  <ListingElements
    bind:elements
    {listing}
    {creator}
    {isEditable}
  />
</div>

<div class="footer">
  <p class="listing-id">
    {I18n('list')}
    -
    {_id}
  </p>
</div>

<style lang="scss">
  @import "general/scss/utils";
  .listing-layout{
    max-width: 40em;
    margin: 0 auto;
    @include display-flex(column, center);
  }
  .listing-id{
    @include display-flex(column, center);
    font-size: small;
  }
</style>
